<template>
  <Modal
    :title="edit ? $t('project.editProjectNo') : $t('project.addProjectNo')"
    @ok="(l) => (this.edit ? update(l) : save(l))"
    :value="value"
    :okText="edit ? $t('project.editProjectNo') : $t('project.addProjectNo')"
    @input="$emit('input', $event)"
  >
    <PageTitle
      :description="
        edit
          ? $t('project.editProjectNoDescription')
          : $t('project.addProjectNoDescription')
      "
    ></PageTitle>
    <div class="u-margin-top-small">
      <SeriesSearch v-model="series" :label="$t('cyclesForm.series')" />
    </div>
    <BaseInput
      class="u-margin-top-small"
      block
      input-id="projectNo"
      :label="$t('project.projectNo')"
      size="sm"
      :placeholder="$t('project.projectNoPlaceholder')"
      v-model="title"
      :icon="'architecture'"
      :mandotary="validActivated"
    ></BaseInput>
  </Modal>
</template>

<script>
import Modal from "../Base/Modal.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Requests from "@/services/Requests";
import SeriesSearch from "@/components/Searches/SeriesSearch.vue";
export default {
  components: {
    Modal,
    PageTitle,
    BaseInput,
    SeriesSearch,
  },
  props: {
    value: {
      default: false,
    },
    initProjectNo: {
      default: "",
    },
    edit: {
      default: false,
      type: Boolean,
    },
    form: {
      default: () => ({
        id: null,
        projectNo: "",
        seriesInfo: null,
      }),
    },
    noRedirect: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      title: this.initProjectNo,
      mainProjectId: null,
      validActivated: false,
      series: null,
    };
  },
  watch: {
    projectNo(value) {
      this.validActivated = value ? true : false;
    },
    value(value) {
      if (value) {
        this.checkProps();
      }
    },
  },

  methods: {
    async save(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.MainProject.Create({
        title: this.title,
        seriesId: this.series.id,
        isActive: true,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("mainProject.success"),
          variant: "success",
          duration: 2500,
        });
        if (this.noRedirect) {
          this.$emit("created:mainProject", {
            id: response.data,
            title: this.title,
            seriesInfo: this.series,
          });
          this.$emit("input", false);
        } else {
          this.$router.push({
            name: "main-projects-id",
            params: {
              mainProjectId: response.data,
            },
          });
        }
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async update(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.MainProject.Update(
        {
          title: this.title,
          seriesId: this.series?.id,
        },
        { params: { id: this.form.id } }
      );
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("mainProject.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    validation() {
      if (this.title && this.series?.id) {
        return true;
      }
      return false;
    },
    async getSeries() {
      if (!this.form?.seriesInfo?.id) {
        return;
      }
      const response = await Requests.Series.GetById({
        params: { id: this.form?.seriesInfo?.id },
      });
      if (response.message === "OK") {
        this.series = response.data;
      }
    },
    async checkProps() {
      if (this.edit) {
        this.title = this.form?.title || "";
        this.mainProjectId = this.form?.id || null;
        await this.getSeries();
      }
      setTimeout(() => {
        document.getElementById("projectNo").focus();
      }, 150);
    },
  },
  mounted() {
    this.checkProps();
  },
};
</script>

<style></style>
